<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('access_logs')"/>

        <app-table
            id="access-logs-table"
            :options="options"
            @getFilteredValues="getFilterValues"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import AccessLogsMixin from "../../../Mixins/AccessLogsMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name  : "AccessLogs",
    mixins: [HelperMixin, AccessLogsMixin, TENANT_BASE_URL],
}
</script>